export default function currencyPairCheck(code = 'NGN', opts = { returnType: "symbol" }) {
    const cryptoMap = {
        USDC: { symbol: "USDC", isCrypto: true, name: "USD Coin" },
        USDT: { symbol: "USDT", isCrypto: true, name: "Tether" },
    };

    const fiatMap = {
        GBP: { symbol: "£", isCrypto: false , name: "Pound Sterling"},
        NGN: { symbol: "₦", isCrypto: false, name: "Naira" },
        USD: { symbol: "$", isCrypto: false, name: "US Dollar" },
        EUR: { symbol: "€", isCrypto: false, name: "Euro" },
        KES: { symbol: "KSh", isCrypto: false, name: "Kenyan Shilling" },
      GHS: { symbol: "GH₵", isCrypto: false, name: "Ghana Cedis" },
    };

    const all = { ...fiatMap, ...cryptoMap };

    if (opts.returnType === "name") return all[code]?.name || code || "--";
    if (opts.returnType === "full") return all[code] || { symbol: code, isCrypto: false, name: code };
  return all[code]?.symbol || code || "--";
}
